import type { BackupVault } from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { mockDalFactory } from '../../../utils';

const vaultsData: BackupVault[] = [
  {
    id: 'b1b1b1b1-4ba2-4c9d-b7f2-84f722051aaf',
    name: 'US East',
    vaultAttributes: {
      cloudProvider: Provider.Aws,
      aws: {
        bucketName: 'my-bucket',
      },
    },
    vaultAccountId: 'b92261dd-5926-4038-9bea-9b5b5e5c3b55',
    providerAccountId: '905476278391',
    isManagedByEon: true,
    region: 'us-east-1',
  },
  {
    id: 'b1b1b1b1-4ba2-4c9d-b7f2-84f722067aaf',
    name: 'US West',
    vaultAttributes: {
      cloudProvider: Provider.Aws,
      aws: {
        bucketName: 'my-bucket',
      },
    },
    vaultAccountId: 'b92261dd-5926-4038-9bea-9b5b5e5c3b55',
    providerAccountId: '905476278391',
    isManagedByEon: true,
    region: 'us-west-1',
  },
  {
    id: '12341-4ba2-4c9d-b7f2-89f722051aaf',
    name: 'US East',
    vaultAttributes: {
      cloudProvider: Provider.Azure,
    },
    vaultAccountId: 'b92261dd-5926-4038-9bea-9b5b5e5c3b56',
    providerAccountId: '91824f15-b4b8-4148-9aef-e61788c57b4d',
    region: 'eastus',
    isManagedByEon: true,
  },
  {
    id: '12341-4ba2-4c9d-b7f2-84f722051aaf',
    name: 'US West',
    vaultAttributes: {
      cloudProvider: Provider.Azure,
    },
    vaultAccountId: 'b92261dd-5926-4038-9bea-9b5b5e5c3b56',
    providerAccountId: '91824f15-b4b8-4148-9aef-e61788c57b4d',
    region: 'westus',
    isManagedByEon: true,
  },
  {
    id: '12341-4ba7-4c9d-b7f2-89f722051aaf',
    name: 'US East',
    vaultAttributes: {
      cloudProvider: Provider.Gcp,
    },
    vaultAccountId: 'b92261dd-5926-4038-9bea-9b5b5e5c3b57',
    providerAccountId: 'platform-prod-302518',
    isManagedByEon: true,
    region: 'us-east1',
  },
  {
    id: '12341-4ba7-4c0d-b7f2-89f722051aaf',
    name: 'US West',
    vaultAttributes: {
      cloudProvider: Provider.Gcp,
    },
    vaultAccountId: 'b92261dd-5926-4038-9bea-9b5b5e5c3b57',
    providerAccountId: 'platform-prod-302518',
    isManagedByEon: true,
    region: 'us-west1',
  },
];

export const vaultsDAL = mockDalFactory(vaultsData, (items, demoSettings) =>
  items
    .filter(
      (item) =>
        item.vaultAttributes.cloudProvider !== Provider.ProviderUnspecified &&
        demoSettings[item.vaultAttributes.cloudProvider]
    )
    .sort((a, b) => {
      if (
        demoSettings.primaryProvider === a.vaultAttributes.cloudProvider &&
        demoSettings.primaryProvider === b.vaultAttributes.cloudProvider
      ) {
        return 0;
      }

      if (demoSettings.primaryProvider === a.vaultAttributes.cloudProvider) {
        return -1;
      }

      if (demoSettings.primaryProvider === b.vaultAttributes.cloudProvider) {
        return 1;
      }

      return 0;
    })
);
